<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mt-2 mb-2">
      <b-alert show variant="info" class="mb-0 p-1">{{
        $t('Click the Detail button to view saved prices.')
      }}</b-alert>
      <b-button variant="primary" size="md" @click="onCreate">{{
        $t('Create New Return Sales Price')
      }}</b-button>
    </div>

    <vue-good-table
      mode="remote"
      :sort-options="{ enabled: false }"
      :total-rows="totalRecords"
      :is-loading.sync="isLoading"
      :pagination-options="{
        enabled: true,
        jumpFirstOrLast: true,
        rowsPerPageLabel: t('Rows per page'),
        ofLabel: t('ofLabel'),
        nextLabel: t('nextLabel'),
        prevLabel: t('prevLabel'),
        dropdownAllowAll: false
      }"
      :show-footer="true"
      :rows="rows"
      :columns="getColumns"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
    >
      <table-no-result-found slot="emptystate" />
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'providerName'">
          {{ props.row.providerName }}
        </span>
        <span v-if="props.column.field === 'customerName'">
          {{ props.row.customerName }}
        </span>
        <span v-if="props.column.field === 'description'">
          {{ props.row.description }}
        </span>
        <span v-if="props.column.field === 'priceType'">
          {{
            props.row.pricingType === 1
              ? $t('Fixed')
              : props.row.pricingType === 2
              ? $t('Percentage')
              : '-'
          }}
        </span>
        <span v-if="props.column.field === 'costPrice'">
          {{ props.row.price }}
        </span>
        <span v-if="props.column.field === 'salePrice'">
          {{ props.row.salePrice }}
        </span>
        <span v-if="props.column.field === 'actions'">
          <span class="d-flex justify-content-center table-icon-buttons">
            <b-button
              :id="`detail-return-fee-${props.row.providerId}`"
              variant="primary"
              type="button"
              size="sm"
              @click="onDetail(props.row)"
            >
              {{ t('Detail') }}
            </b-button>
          </span>
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { BButton, BAlert } from 'bootstrap-vue';
import { VueGoodTable } from 'vue-good-table';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import useService from '@/auth/service/useService';

export default {
  name: 'SalePricesSenderPrices',
  components: {
    VueGoodTable,
    BButton,
    BAlert
  },

  data() {
    return {
      isLoading: false,
      rows: [],
      totalRecords: 0,
      filter: {
        page: 1,
        limit: 10
      }
    };
  },

  computed: {
    getColumns() {
      return [
        { label: this.$t('Customer'), field: 'customerName' },
        { label: this.$t('Provider'), field: 'providerName' },
        { label: this.$t('Actions'), field: 'actions', sortable: false }
      ];
    }
  },

  methods: {
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps };
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.filter.page = 1;
      this.updateParams({ limit: params.currentPerPage });
      this.loadItems();
    },

    loadItems() {
      this.isLoading = true;
      useService
        .getAllCustomerReturnFeesForSale()
        .then(response => {
          const list = Array.isArray(response.data) ? response.data : [];
          this.rows = list.map(item => ({
            id: item.id,
            customerId: item.customer && item.customer.id,
            customerName: item.customer && (item.customer.companyName || item.customer.name),
            providerId: item.provider && item.provider.id,
            providerName: item.provider && item.provider.name,
            price: item.price
          }));
          this.totalRecords = this.rows.length;
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              if (this.$toast) {
                this.$toast.error(item.message);
              }
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    onCreate() {
      this.$router.push({ name: 'sale-prices-consignor-prices-create' });
    },

    onDetail(row) {
      this.$router.push({
        name: 'sale-prices-consignor-prices-detail',
        params: { providerId: row.providerId, customerId: row.customerId }
      });
    }
  },

  created() {
    this.loadItems();
  },

  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
